import type { State } from '../types';

const Debug = ({ state }: { state: State }) => {
  return (
    <pre
      style={{
        border: '2px solid #404040',
        color: '#404040',
        fontSize: '12px',
        position: 'absolute',
        overflowY: 'scroll',
        width: '30%',
        maxHeight: '100vh',
        right: 0,
        top: 0,
        backgroundColor: 'white',
        padding: '4px',
        borderRadius: '4px',
        zIndex: 1,
      }}
    >
      <details>
        <summary>DEBUG</summary>
        {JSON.stringify(state, null, 2)}
      </details>
    </pre>
  );
};

export default Debug;
